module.exports = __webpack_public_path__ + "static/Bandages1-6215cb8bc2b61fb422a7716faf401f57.jpg";